export var parseCreditcard = function parseCreditcard(account) {
  // process default value of expiry year & month of creditcard, i.e., expiryDate = 2021-03
  var expiryYear = void 0,
      expiryMonth = void 0;
  var indexOfValidDate = account.expiryDate && account.expiryDate.indexOf('-');
  if (indexOfValidDate > 0) {
    // get default values of expiryMonth && expiryYear from stored Account
    expiryYear = account.expiryDate.substr(0, indexOfValidDate);
    expiryMonth = account.expiryDate.substr(indexOfValidDate + 1);
  } else {
    // get default values of expiryMonth && expiryYear from defaultValues (selectedOption/account)
    if (account.expiryMonth && account.expiryMonth.length === 2) {
      expiryMonth = account.expiryMonth;
    }
    if (account.expiryYear && account.expiryYear.length === 4) {
      expiryYear = account.expiryYear;
    }
  }

  return {
    cardHolder: account.cardHolder,
    cardNumber: account.maskedAccount || account.cardNumber,
    expiryYear: expiryYear,
    expiryMonth: expiryMonth
  };
};

export var parseNeteller = function parseNeteller(account) {
  return {
    account: account.maskedAccount || account.account
  };
};

export var parseVenusPoint = function parseVenusPoint(account) {
  return {
    account: account.maskedAccount || account.account
  };
};

export var parseVega = function parseVega(account) {
  return {
    account: account.maskedAccount || account.account
  };
};

export var parsePhoneNumber = function parsePhoneNumber(account) {
  return {
    phoneNumber: account.phoneNumber || account.maskedAccount
  };
};